import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsFastForward: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 4.8L0 0v16l6-4.8V16l10-8L6 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsFastForward
